/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Starting_Event_IdInputs */



/**
* | output |
* | --- |
* | "Starting Event Id" |
*
* @param {Starting_Event_IdInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const starting_event_id = /** @type {((inputs?: Starting_Event_IdInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Starting_Event_IdInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("ID d’événement de départ")
	if (locale === "de") return /** @type {LocalizedString} */ ("Startereignis-ID")
	if (locale === "it") return /** @type {LocalizedString} */ ("ID evento iniziale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Идентификатор начального события")
	if (locale === "es") return /** @type {LocalizedString} */ ("Id. de evento inicial")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("起始事件 ID")
	if (locale === "ja") return /** @type {LocalizedString} */ ("開始イベントID")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रारंभ घटना आईडी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("ID do evento inicial")
	return /** @type {LocalizedString} */ ("Starting Event Id")
});